/* ==========================================================================
   OBAÏA Paris — Modales (Nelson, Figma 840:8752)
   window.OBAIA_MODALES.ouvrir('newsletter' | 'pays' | 'cookies' | 'prevenir') / .fermer()
   window.OBAIA_COOKIES.ouvrir() : rouvre le choix des cookies (bouton des pages légales).
   ========================================================================== */
(function () {
  'use strict';
  var d = document, ouverte = null, retour = null;
  var $ = function (s, r) { return (r || d).querySelector(s); }, $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var stock = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };
  var emailOk = function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((v || '').trim()); };

  /* ---------- Ouverture / fermeture communes ---------- */
  function ouvrir(nom) {
    var m = $('[data-modale="' + nom + '"]'); if (!m) return;
    if (ouverte && ouverte !== m) fermer(true);
    retour = d.activeElement; ouverte = m;
    if (nom === 'pays') {
      var h = $('[data-header]'), b = h ? Math.max(0, Math.round(h.getBoundingClientRect().bottom)) : 0;
      m.style.setProperty('--mod-top', b + 'px');
      if (h && window.matchMedia('(min-width: 768px)').matches) h.classList.add('is-recherche');
    }
    m.hidden = false; d.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { requestAnimationFrame(function () { m.classList.add('is-open'); }); });
    var boite = $('.mod__boite', m); boite.setAttribute('tabindex', '-1');
    setTimeout(function () { boite.focus({ preventScroll: true }); }, 60);
  }
  function fermer(vite) {
    var m = ouverte; if (!m) return; ouverte = null;
    m.classList.remove('is-open');
    var h = $('[data-header]'); if (h && m.getAttribute('data-modale') === 'pays') h.classList.remove('is-recherche');
    d.documentElement.style.overflow = '';
    setTimeout(function () { m.hidden = true; }, vite === true ? 0 : 350);
    if (m.getAttribute('data-modale') === 'newsletter') {
      refusNewsletter(false);
      if (m._orig) setTimeout(function () { $('#nlm-titre', m).textContent = m._orig.t; $('.nlm__texte', m).textContent = m._orig.x; $('input[name="contact[tags]"]', m).value = m._orig.tag; }, 400);
    }
    if (retour && retour.focus) retour.focus({ preventScroll: true });
  }
  d.addEventListener('click', function (e) { if (e.target.closest('[data-modale-fermer]')) fermer(); });
  d.addEventListener('keydown', function (e) {
    if (!ouverte) return;
    if (e.key === 'Escape') return fermer();
    if (e.key !== 'Tab') return;
    var f = $$('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), textarea', ouverte).filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && d.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && d.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });

  /* ---------- 1. Newsletter : 8 s ou 50 % de défilement, une fois ; « Non merci » = 30 jours ---------- */
  function refusNewsletter(jours30) { stock.set('obaia-nl', jours30 ? 'non:' + Date.now() : (stock.get('obaia-nl') || 'vu:' + Date.now())); }
  function newsletter() {
    var m = $('[data-modale="newsletter"]'); if (!m) return;
    var v = stock.get('obaia-nl') || '';
    if (v === 'inscrite') return;
    if (v.indexOf('non:') === 0 && Date.now() - parseInt(v.slice(4), 10) < 30 * 864e5) return;
    if (v.indexOf('vu:') === 0) return;                         // déjà montrée une fois
    var fait = false, declencher = function () {
      if (fait) return;
      if (ouverte || $('[data-cookies-bandeau]:not([hidden])')) { setTimeout(declencher, 3000); return; }   // jamais par-dessus une autre fenêtre ni la bannière cookies
      fait = true; window.removeEventListener('scroll', auDefilement); ouvrir('newsletter');
    };
    var auDefilement = function () {
      var max = d.documentElement.scrollHeight - innerHeight;
      if (max > 0 && scrollY / max >= .5) declencher();
    };
    setTimeout(declencher, (parseInt(m.getAttribute('data-delai'), 10) || 8) * 1000);
    window.addEventListener('scroll', auDefilement, { passive: true });

    var form = $('[data-nlm-form]', m), champ = $('[data-nlm-champ]', m), input = $('input[type="email"]', m), msg = $('[data-nlm-msg]', m), texte = msg.textContent;
    input.addEventListener('input', function () { champ.classList.remove('is-erreur'); msg.className = 'nlm__mention'; msg.textContent = texte; });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!emailOk(input.value)) { champ.classList.add('is-erreur'); msg.className = 'nlm__mention is-erreur'; msg.textContent = msg.getAttribute('data-erreur'); return; }
      fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } }).then(function (r) {
        if (/challenge/.test(r.url)) { form.submit(); return; }          // vérification anti-robot de Shopify : envoi classique
        stock.set('obaia-nl', 'inscrite');
        msg.className = 'nlm__mention is-ok'; msg.textContent = msg.getAttribute('data-ok');
        champ.hidden = true; setTimeout(fermer, 2500);
      }).catch(function () { form.submit(); });
    });
    $('[data-nlm-non]', m).addEventListener('click', function () { refusNewsletter(true); stock.set('obaia-nl', 'non:' + Date.now()); fermer(); });
  }

  /* ---------- 2. Pays et langue : « FR · EUR € » de l'en-tête, sélecteur du pied de page ---------- */
  function pays() {
    var m = $('[data-modale="pays"]'); if (!m) return;
    $$('.header__lang, .drawer__foot, .footer__select, [data-pays-ouvrir]').forEach(function (el) {
      el.setAttribute('role', 'button'); el.setAttribute('tabindex', '0'); el.setAttribute('aria-haspopup', 'dialog');
      var go = function (e) { e.preventDefault(); var dr = $('[data-menu-close]'); if (el.classList.contains('drawer__foot') && dr) dr.click(); ouvrir('pays'); };
      el.addEventListener('click', go);
      el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') go(e); });
    });
    var tous = $('[data-pays-tous]', m);
    if (tous) tous.addEventListener('click', function () { $$('[data-pays-cache]', m).forEach(function (x) { x.hidden = false; }); tous.hidden = true; });
  }

  /* ---------- 3. Cookies : API Customer Privacy de Shopify ---------- */
  function cookies() {
    var b = $('[data-cookies-bandeau]'), p = $('[data-modale="cookies"]'); if (!b || !p) return;
    var api = function () { return window.Shopify && window.Shopify.customerPrivacy; };
    // Choix mémorisé 6 mois sur ce navigateur (durée recommandée par la CNIL) : retour de la cliente du 02/11,
    // « la pop-up revient trop souvent malgré Tout refuser / Tout accepter ». Shopify peut perdre son propre cookie
    // d'accord (protections de Safari, passage au paiement…) : c'est le choix mémorisé ici qui fait foi.
    var SIX_MOIS = 182 * 864e5;
    var memo = function () {
      var v = null; try { v = JSON.parse(stock.get('obaia-ck') || 'null'); } catch (e) {}
      if (!v || typeof v !== 'object') return null;
      if (!v.t) { v.t = Date.now(); stock.set('obaia-ck', JSON.stringify(v)); }   // choix faits avant le 02/11 : comptés d'aujourd'hui
      return Date.now() - v.t < SIX_MOIS ? v : null;
    };
    var pourShopify = function (v) { return { analytics: !!v.analytics, marketing: !!v.marketing, preferences: !!v.analytics, sale_of_data: !!v.marketing }; };
    var choisir = function (analytics, marketing) {
      var choix = pourShopify({ analytics: analytics, marketing: marketing });
      stock.set('obaia-ck', JSON.stringify({ analytics: analytics, marketing: marketing, preferences: analytics, sale_of_data: marketing, t: Date.now() }));
      var a = api(); if (a && a.setTrackingConsent) a.setTrackingConsent(choix, function () {});
      d.dispatchEvent(new CustomEvent('obaia:consentement', { detail: choix }));   // snippets/obaia-suivi : Google / Meta
      b.hidden = true; if (ouverte === p) fermer();
    };
    var remplir = function () {
      var a = api(), v = {};
      try { v = JSON.parse(stock.get('obaia-ck') || '{}'); } catch (e) {}
      if (a && a.analyticsProcessingAllowed) { v.analytics = a.analyticsProcessingAllowed(); v.marketing = a.marketingAllowed(); }
      $('[data-ck-cat="analytics"]', p).checked = !!v.analytics;
      $('[data-ck-cat="marketing"]', p).checked = !!v.marketing;
    };
    $$('[data-ck]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var a = btn.getAttribute('data-ck');
        if (a === 'accepter') choisir(true, true);
        else if (a === 'refuser') choisir(false, false);
        else if (a === 'personnaliser') { remplir(); ouvrir('cookies'); }
        else if (a === 'enregistrer') choisir($('[data-ck-cat="analytics"]', p).checked, $('[data-ck-cat="marketing"]', p).checked);
      });
    });
    window.OBAIA_COOKIES = { ouvrir: function () { remplir(); ouvrir('cookies'); } };
    // Lien « Cookies » du pied de page (data-cookies, Moha) : rouvre ce choix plutôt que la page
    d.addEventListener('click', function (e) {
      var l = e.target.closest('[data-cookies]'); if (!l || e.metaKey || e.ctrlKey) return;
      e.preventDefault(); e.stopPropagation(); window.OBAIA_COOKIES.ouvrir();
    }, true);
    var montrer = function () {
      var a = api(), v = memo();
      if (v) {
        // Choix déjà fait : on ne redemande pas ; si Shopify l'a oublié, on le lui renvoie en silence
        b.hidden = true;
        if (a && a.shouldShowBanner && a.shouldShowBanner() && a.setTrackingConsent) a.setTrackingConsent(pourShopify(v), function () {});
        return;
      }
      b.hidden = !(a && a.shouldShowBanner ? a.shouldShowBanner() : true);
    };
    // Un seul choix à faire (retour du 01/11 : « les cookies réagissent à chaque clic ») : si l'accord arrive par
    // Shopify (bannière Shopify encore active, autre onglet…), la bannière OBAÏA se ferme aussitôt, sans second clic.
    d.addEventListener('visitorConsentCollected', function () {
      var a = api(); if (a && a.shouldShowBanner && a.shouldShowBanner()) return;
      b.hidden = true; if (ouverte === p) fermer();
    });
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (err) b.hidden = !!memo(); else montrer(); });
    } else montrer();
  }

  /* ---------- 4. Me prévenir (coloris épuisé, fiche produit) ---------- */
  function prevenir() {
    var m = $('[data-modale="prevenir"]'); if (!m) return;
    d.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-me-prevenir]'); if (!btn) return;
      e.preventDefault();
      var pdt = btn.closest('[data-section="produit"]') || d;
      var coloris = ($('[data-couleur-nom]', pdt) || {}).textContent || '';
      var ph = $('[data-coloris]:checked', pdt), img = ph && ph.closest('label') && $('img', ph.closest('label'));
      img = img || $('[data-barre-image] img', pdt) || $('.pdt img', pdt);
      var nom = btn.getAttribute('data-produit') || '';
      $('[data-mp-nom]', m).textContent = nom;
      $('[data-mp-statut]', m).textContent = (coloris ? coloris.trim() + ' · ' : '') + (btn.getAttribute('data-epuise') || 'Épuisé');
      var im = $('[data-mp-image]', m);
      if (img) { im.src = img.currentSrc || img.src; im.alt = nom; im.hidden = false; } else im.hidden = true;
      var id = ($('input[name="id"]', pdt) || {}).value || '';
      $('[data-mp-body]', m).value = 'Me prévenir du retour : ' + nom + (coloris ? ' — ' + coloris.trim() : '') + (id ? ' (variante ' + id + ')' : '') + ' — ' + location.href;
      $('[data-mp-ok]', m).hidden = true;
      ouvrir('prevenir');
    });
    var form = $('[data-mp-form]', m), email = $('[data-mp-email]', m);
    email.addEventListener('input', function () { email.closest('.mp__champ').classList.remove('is-erreur'); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!emailOk(email.value)) { email.closest('.mp__champ').classList.add('is-erreur'); email.focus(); return; }
      fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } }).then(function (r) {
        if (/challenge/.test(r.url)) { form.submit(); return; }
        $('[data-mp-ok]', m).hidden = false;
      }).catch(function () { form.submit(); });
    });
  }

  function init() { newsletter(); pays(); cookies(); prevenir(); }
  /* ---------- Liens « Je m'inscris » (diapositive Black Friday de l'accueil, retour du 31/10) ----------
     <a href="#newsletter" data-nl-ouvrir data-nl-titre data-nl-texte data-nl-tag> ouvre la pop-up newsletter avec
     ce titre et ce texte, et ajoute l'étiquette (ex. black-friday) à l'inscrite. Sans pop-up : défile jusqu'au
     bloc newsletter de la page. */
  d.addEventListener('click', function (e) {
    var a = e.target.closest('[data-nl-ouvrir]'); if (!a) return;
    var m = $('[data-modale="newsletter"]');
    if (!m) {
      var bloc = $('[data-section="newsletter"]'); if (!bloc) return;
      e.preventDefault(); bloc.scrollIntoView({ behavior: 'smooth' });
      var champ = $('input[type="email"]', bloc); if (champ) setTimeout(function () { champ.focus({ preventScroll: true }); }, 600);
      return;
    }
    e.preventDefault();
    var t = $('#nlm-titre', m), x = $('.nlm__texte', m), tag = $('input[name="contact[tags]"]', m);
    if (!m._orig) m._orig = { t: t.textContent, x: x.textContent, tag: tag.value };
    t.textContent = a.getAttribute('data-nl-titre') || m._orig.t;
    x.textContent = a.getAttribute('data-nl-texte') || m._orig.x;
    tag.value = m._orig.tag + (a.getAttribute('data-nl-tag') ? ', ' + a.getAttribute('data-nl-tag') : '');
    ouvrir('newsletter');
  });

  window.OBAIA_MODALES = { ouvrir: ouvrir, fermer: fermer };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
